"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var state = {
  isAddRoute: false,
  isFullScreen: false,
  TRIP_STATUS: [],
  TRIP_TYPE: [],
  TRIP_CLASS: [],
  KIND_OF_CUSTOMER: [],
  SC_SYSTEM_LOGS_SUFFIX_MAPPING: []
};
var mutations = {
  SET_ADDROUTE: function SET_ADDROUTE(state, data) {
    state.isAddRoute = data;
  },
  CHANGE_FULLSCREEN: function CHANGE_FULLSCREEN(state, data) {
    state.isFullScreen = data;
  },
  SET_TRIP_STATUS: function SET_TRIP_STATUS(state, data) {
    state.TRIP_STATUS = data;
  },
  SET_TRIP_TYPE: function SET_TRIP_TYPE(state, data) {
    state.TRIP_TYPE = data;
  },
  SET_TRIP_CLASS: function SET_TRIP_CLASS(state, data) {
    state.TRIP_CLASS = data;
  },
  SET_KIND_OF_CUSTOMER: function SET_KIND_OF_CUSTOMER(state, data) {
    state.KIND_OF_CUSTOMER = data;
  },
  SET_SC_SYSTEM_LOGS_SUFFIX_MAPPING: function SET_SC_SYSTEM_LOGS_SUFFIX_MAPPING(state, data) {
    state.SC_SYSTEM_LOGS_SUFFIX_MAPPING = data;
  }
};
var actions = {
  setAddRoute: function setAddRoute(_ref, _ref2) {
    var commit = _ref.commit;
    var isAddRoute = _ref2.isAddRoute;
    return new Promise(function (resolve) {
      commit('SET_ADDROUTE', isAddRoute);
      resolve();
    });
  },
  changeFullScreen: function changeFullScreen(_ref3, data) {
    var commit = _ref3.commit;
    return new Promise(function (resolve) {
      commit('CHANGE_FULLSCREEN', data);
      resolve();
    });
  },
  setTripStatus: function setTripStatus(_ref4, data) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TRIP_STATUS', data);
      resolve();
    });
  },
  setTripType: function setTripType(_ref5, data) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TRIP_TYPE', data);
      resolve();
    });
  },
  setTripClass: function setTripClass(_ref6, data) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TRIP_CLASS', data);
      resolve();
    });
  },
  setKindOfCustomer: function setKindOfCustomer(_ref7, data) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_KIND_OF_CUSTOMER', data);
      resolve();
    });
  },
  setScSystemLogsSuffixMapping: function setScSystemLogsSuffixMapping(_ref8, data) {
    var commit = _ref8.commit;
    return new Promise(function (resolve) {
      commit('SET_SC_SYSTEM_LOGS_SUFFIX_MAPPING', data);
      resolve();
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};